import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g10-sos-map-layout',
  templateUrl: './sos-map-layout.component.html',
  styleUrls: ['./sos-map-layout.component.css']
})
export class SosMapLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
